import { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";

import Loader from "@/components/loader";
// import { useBrandColorContext } from "@/contexts/BrandColorContext";
import { useCurrentPlatformContext } from "@/contexts/CurrentPlatformContext";
import { useBreakpoint } from "@/hooks/userBreakPoint";
// import { FormattedMessage } from "@/i18n";
// import { Link } from "@/ui";

import { DashboardHeader } from "./DashboardHeader";
import { DASHBOARD_LAYOUT_CONTENT_ID } from "./DashboardLayout.constants";
import { DashboardScopeGate } from "./DashboardScopeGate";
import { DashboardSidebar } from "./DashboardSidebar";

export const DashboardLayout = () => {
  // const { supportEmail } = useBrandColorContext();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isSmallScreen = useBreakpoint("md", "down");
  const location = useLocation();
  const { platform } = useCurrentPlatformContext();

  useEffect(() => {
    if (isDrawerOpen && isSmallScreen) {
      setIsDrawerOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Every piece of chrome below — sidebar, header, nav-link filter, global
  // search — calls `useCurrentPlatform`, which THROWS on a null platform, so
  // the shell may only mount once a platform exists.
  //
  // `SplashScreenProvider` already holds the whole tree back while platform
  // resolution is in flight, so reaching this point with `platform === null`
  // means resolution settled on nothing — `GET /platforms/me/available`
  // answered 204. `CurrentPlatformGuard` routes that state to /onboarding, but
  // /onboarding is itself a child of this layout, so the escape hatch mounted
  // the very chrome it was escaping: the throw surfaced as react-router's bare
  // "Unexpected Application Error! Current platform not found" instead of a
  // page. Rendering the route without the chrome keeps the destination
  // reachable.
  //
  // `DashboardScopeGate` is deliberately skipped here: it blocks on the
  // organization / league capability sets, which need not resolve for an
  // account that has no platform, and a spinner that never clears would be the
  // same dead end in a different costume. The only route the guard allows in
  // this state is /onboarding, which has no capability gate of its own.
  if (!platform) {
    return (
      <div className="flex h-full w-full flex-col overflow-auto bg-new-background md:p-5 p-4">
        <Suspense
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <Loader />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
    );
  }

  return (
    <div className="flex h-full overflow-auto w-full">
      <DashboardSidebar isOpen={isDrawerOpen} onOpenChange={setIsDrawerOpen} />
      <div
        id={DASHBOARD_LAYOUT_CONTENT_ID}
        className="flex-1 flex flex-col relative overflow-auto [scrollbar-gutter:stable]"
      >
        <DashboardHeader
          onMenuClick={() => {
            setIsDrawerOpen(true);
          }}
        />
        <div className="flex-1 bg-new-background md:p-5 p-4 flex flex-col">
          <Suspense
            fallback={
              <div className="flex-1 flex items-center justify-center">
                <Loader />
              </div>
            }
          >
            <DashboardScopeGate>
              <Outlet />
            </DashboardScopeGate>
          </Suspense>
          {/* <p className="preset-body-md text-new-primary text-center mt-auto py-8">
            <FormattedMessage
              i18nKey={"general.components.supportFooter.text"}
              values={{ supportEmail }}
              components={{
                supportEmailLink: (
                  <Link to={`mailto:${supportEmail}`} target="_blank">
                    {supportEmail}
                  </Link>
                ),
              }}
            />
          </p> */}
        </div>
      </div>
    </div>
  );
};
